import gql from 'graphql-tag';

export const JOB_STATUS = `
    query{
        jobStatuses{
        id
        name
        name_en
        name_ar
        created_at
        }
    }
`
export const GET_JOB = `
query($job_status_id  :   Int  $is_Draft : Boolean $is_accepted : Boolean $is_done : Boolean , $is_answered : Boolean ){
    me{
      id
    companyAuth{
      jobsGet(Inputs: {
        job_status_id : $job_status_id,
        is_Draft : $is_Draft
      }, first: 1000){
       data{
        id
        title
        brif
        created_at
        tags{
          name
        }
        company{id name}
        questions{
          id title
        }
        job_type{id}
        job_status{id}
        salary{salary_from salary_to currency_type{id}}
        job_level_of_experience_type{id}
        ApplicationsGet(Inputs: {
            is_answered : $is_answered,
            is_accepted : $is_accepted,
            is_done : $is_done 
      }, first: 1000)
        {
             data{id}
        }
      }
    }
    }
    }
  }
`
export const GET_JOB_HOME = gql`
query($job_status_id  :   Int  $is_Draft : Boolean $is_accepted : Boolean $is_done : Boolean , $is_answered : Boolean ){
    me{
      id
    companyAuth{
      jobsGet(Inputs: {
        job_status_id : $job_status_id,
        is_Draft : $is_Draft
      }, first: 3){
       data{
        id
        title
        brif
        created_at
        tags{
          name
        }
        company{id name}
        questions{
          id title
        }
        job_type{id}
        job_status{id}
        salary{salary_from salary_to currency_type{id}}
        job_level_of_experience_type{id}
        ApplicationsGet(Inputs: {
            is_answered : $is_answered,
            is_accepted : $is_accepted,
            is_done : $is_done 
      }, first: 1000)
        {
             data{id}
        }
      }
    }
    }
    }
  }
`
export const CREATE_MESSAGE = gql`
mutation( $user_id : Int $company_id : Int  $text : Text){
  messageCreate(Inputs: {
    user_id : $user_id
    company_id : $company_id
    text: $text
  }){
    Status{
      code
      title
      check
    }
    message{
      id
      text
    }
  }
}
`;
export const CREATE_JOB = gql`
mutation( $title : Title! $job_type_id : Int $job_level_of_experience_type_id : Int $brif : Text
  $is_Draft : Boolean $salaryInput :salaryInput  $tags : [ShortText!]  $questionInputs : [questionInputs!]){
    jobCreate(Inputs: {
      title : $title
      job_type_id : $job_type_id
      job_level_of_experience_type_id : $job_level_of_experience_type_id 
      brif :  $brif
      tags : $tags
      is_Draft : $is_Draft
      salaryInput : $salaryInput
      questionInputs :$questionInputs
    }){
      Status{
        check
        message
      }
    }
  }
`
export const EDIT_JOB = gql`
mutation( 
  $id : Int
  $job_status_id  : Int
  $title : Title! $job_type_id : Int $job_level_of_experience_type_id : Int 
  $brif : Text
  $is_Draft : Boolean 
  $salaryInput :salaryInput 
  $delete_old_question : Boolean
  $tags : [ShortText!]  
  $add_question_inputs  : [questionInputs!]
  ){
    jobEdit(Inputs: {
      job : {id : $id}
      job_status_id : $job_status_id 
      title : $title
      job_type_id : $job_type_id
      job_level_of_experience_type_id : $job_level_of_experience_type_id 
      brif :  $brif
      is_Draft : $is_Draft
      salaryInput : $salaryInput
      tags : $tags
      delete_old_question : $delete_old_question
      add_question_inputs  :$add_question_inputs 
    }){
      Status{
        check
        message
      }
      job{
        id
        title
      }
    }
  }
`
export const DELETE_QUESTION = gql`
mutation($question_id : Int ){
    questionDelete(Inputs: {
      id : $question_id
    }){
      Status{
        code 
        check
        message
      }
    }
  }
`
export const EDIT_QUESTION = gql`
mutation(
    $question_id : Int!
    $questionInputs : questionInputs
) {
    questionEdit(
        Inputs : {
            question : {id : $question_id}
            questionInputs : $questionInputs
        }
    ) {
        Status {
            code
            message
        }
    }
}`



  
export const UPDATE_JOP = gql`
query($id : Int!){
    jobFind(id : $id){
      id
      job_status { id name}
      job_type { id name}
      job_level_of_experience_type { id name}
      title
      brif
      salary{ salary_from salary_to currency_type{id}}
      is_Draft
      tags { id name}
      questions {
        id title 
      }
    }
  }`